<script>
  import { onMount } from "svelte";
  import { apiCall } from "../httpCommon";
  import Card from "@smui/card";
  import Textfield from "@smui/textfield";
  import HelperText from "@smui/textfield/helper-text/index";
  import { exclude } from "@smui/common/exclude.js";

  let passedValue = null;
  export { passedValue as value };
  export let error = null;
  // export let label;
  export let helperText = null;
  export let helperPersistent = false;
  
  let value = (passedValue === null || passedValue === undefined) ? "" : passedValue;
  let invalid;
  let errVal = null;
  export let variant = 'standard'

  $: helperTextVal = error || helperText || "";

  $: props = exclude($$props, ["error", "value"]);
  $: {
    const hasErr = error !== undefined && error !== null;
    if (hasErr) {
      if (errVal === null) {
        errVal = value;
      }
    } else {
      if (errVal !== null) {
        errVal = null;
      }
    }

    invalid = errVal === value;
    // console.log(`${label} invalid: ${invalid}, error: ${error}`);
  }

  $: if (
    (passedValue && value !== passedValue) ||
    (passedValue && value != "")
  ) {
    value = passedValue === null ? "" : passedValue;
  }

  function changed(event) {
    const newValue = event.target.value;
    if (newValue !== passedValue) {
      passedValue = newValue;
    }
    //console.log(`${label} changed to ${newValue} invalid now ${invalid}`);
  }
</script>

<span>
  <Textfield
    {value}
    {variant}
    bind:invalid
    on:change
    on:input={changed}
    on:input
    {...props} />
  <HelperText validationMsg={error != null} persistent={helperPersistent}>
    {helperTextVal}
  </HelperText>
</span>
